import React from 'react';
import { Phone, Mail, Clock, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { companyEmail, companyPhone, whatsappLink } from '../mock';

export const ContactSection = () => {
  return (
    <section id="contato" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A2540] mb-4">
            Entre em Contato
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Estamos prontos para atender você
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center p-6 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-[#0A2540] rounded-full flex items-center justify-center mx-auto mb-4">
              <Phone className="text-white" size={28} />
            </div>
            <h3 className="text-lg font-bold text-[#0A2540] mb-2">Telefone</h3>
            <p className="text-gray-600">{companyPhone}</p>
          </div>

          <div className="text-center p-6 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-[#8B3A9C] rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="text-white" size={28} />
            </div>
            <h3 className="text-lg font-bold text-[#0A2540] mb-2">E-mail</h3>
            <p className="text-gray-600 break-all">{companyEmail}</p>
          </div>

          <div className="text-center p-6 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-[#F4D03F] rounded-full flex items-center justify-center mx-auto mb-4">
              <Clock className="text-[#0A2540]" size={28} />
            </div>
            <h3 className="text-lg font-bold text-[#0A2540] mb-2">Horário</h3>
            <p className="text-gray-600">Seg-Sex: 8h-18h</p>
            <p className="text-gray-600">Sáb: 8h-14h</p>
          </div>

          <div className="text-center p-6 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center mx-auto mb-4">
              <MapPin className="text-white" size={28} />
            </div>
            <h3 className="text-lg font-bold text-[#0A2540] mb-2">Localização</h3>
            <p className="text-gray-600">São Paulo, SP</p>
            <p className="text-gray-600">Brasil</p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <Button
            asChild
            size="lg"
            className="bg-[#25D366] hover:bg-[#20BD5A] text-white font-bold px-12 py-6 text-lg">

            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              Fale Conosco no WhatsApp
            </a>
          </Button>
        </div>
      </div>
    </section>);

};